<div class="flex flex-1 flex-col gap-1">
  <div class="flex h-40 rounded-md border bg-slate-200">
    @if (!imageData) {
      <div class="flex flex-1 items-center justify-center">
        <i class="fa-light fa-file-image fa-3x"></i>
      </div>
    }
    @if (imageData) {
      <div class="flex flex-1 items-center justify-center p-2">
        <img crossorigin [src]="imageData" class="max-h-full" />
      </div>
    }
  </div>

  @if (!readOnly) {
    <div
      [filePond]="{
        maxFiles: 1,
        acceptedFileTypes: ['image/*'],
        onremovefile: onRemoveImage,
        instantUpload: true,
        server: {
          process: onProcessFile
        },
        labelIdle:
          'Trascina e rilascia l\'immagine o <span class=\'filepond--label-action\'> clicca qui </span> per selezionarla'
          | transloco
      }"
      [disablePaste]="true"
      [filePondInitialFile]="initialFile"
    ></div>
  }

  <div class="flex flex-row gap-2 items-center">
    <div class="flex flex-row gap-1 items-center">
      <snt-button-icon
        [disabled]="readOnly"
        icon="fa-light fa-align-left"
        (onClick)="onAlignChanged('left')"
        [sntTooltip]="'Allinea a sinistra' | transloco"
        [type]="align() === 'left' ? 'primary' : 'default'"
        [size]="'xs'"
      ></snt-button-icon>

      <snt-button-icon
        [disabled]="readOnly"
        icon="fa-light fa-align-center"
        [sntTooltip]="'Allinea al centro' | transloco"
        (onClick)="onAlignChanged('center')"
        [type]="align() === 'center' ? 'primary' : 'default'"
        [size]="'xs'"
      ></snt-button-icon>

      <snt-button-icon
        [disabled]="readOnly"
        icon="fa-light fa-align-right"
        [sntTooltip]="'Allinea a destra' | transloco"
        (onClick)="onAlignChanged('right')"
        [type]="align() === 'right' ? 'primary' : 'default'"
        [size]="'xs'"
      ></snt-button-icon>
    </div>

    <div class="w-px bg-slate-200"></div>

    <div class="flex flex-row gap-1 items-center">
      @for (_size of [1, 2, 3, 4, 5]; track $index) {
        <snt-button-icon
          [disabled]="readOnly"
          icon="fa-light fa-{{ _size }}"
          (onClick)="onSizeChanged(_size)"
          [type]="size() === _size ? 'primary' : 'default'"
          [size]="'xs'"
        ></snt-button-icon>
      }
    </div>
  </div>

  <dx-text-area
    [readOnly]="readOnly"
    [value]="caption()"
    [placeholder]="'Didascalia' | transloco"
    valueChangeEvent="keyup"
    (onValueChanged)="onCaptionValueChanged($event)"
    class="text-xxs"
  ></dx-text-area>
</div>
